import { createSlice } from '@reduxjs/toolkit'
import { register, syncInitialState } from '../../helpers/reducerRegistry'
import { CURRENCY, UNIT } from '../../utils/currency'
import { SCREEN } from './constant'
import { calculateMinUnit, convertExchangeRates } from './helper'

const initialState = {
  exchangeRates: {},
  ...Object.values(SCREEN).reduce(
    (acc, cur) => ({
      ...acc,
      [cur]: {
        allowSetDefaultUnit: true,
        currency: CURRENCY.VND,
        unit: UNIT.TRILLION.unitKey,
      },
    }),
    {},
  ),
}

const name = 'common/selectCurrencyUnit'
const persistKeys = Object.values(SCREEN)

const slice = createSlice({
  name,
  initialState: syncInitialState({
    name,
    initialState,
    persistKeys,
    persistKeysDisableCheckLocation: persistKeys,
  }),
  reducers: {
    resetStoreSelectCurrencyUnit: () => initialState,
    resetStoreSelectCurrencyUnitExceptExchangeRates: (state) => ({
      ...initialState,
      exchangeRates: state.exchangeRates,
    }),
    changeExchangeRates: (state, { payload }) => {
      state.exchangeRates = convertExchangeRates(payload)
    },
    changeCurrency: (state, { payload }) => {
      const { screen, value } = payload
      state[screen].currency = value
    },
    changeAllCurrency: (state, { payload }) => {
      Object.values(SCREEN).forEach((screen) => {
        state[screen].currency = payload
      })
    },
    changeUnit: (state, { payload }) => {
      const { screen, value } = payload
      state[screen].unit = value
    },
    changeAllUnit: (state, { payload }) => {
      Object.values(SCREEN).forEach((screen) => {
        state[screen].unit = payload
      })
    },
    changeAllowSetDefaultUnit: (state, { payload }) => {
      const { screen, value } = payload
      state[screen].allowSetDefaultUnit = value
    },
    calculateDefaultUnit: (state, action) => {
      const { screen, getValues } = action.payload
      if (state[screen].allowSetDefaultUnit) {
        const values = getValues()
        const exchangeRates = JSON.parse(JSON.stringify(state.exchangeRates))
        if (Object.keys(exchangeRates).length) {
          state[screen].unit = calculateMinUnit({
            values,
            oldUnit: state[screen].unit,
            currency: state[screen].currency,
            exchangeRates,
          })
        }
      }
    },
  },
})

export const selectAllowSetDefaultUnit = (screen) => (state) =>
  state[slice.name][screen].allowSetDefaultUnit
export const selectCurrency = (screen) => (state) =>
  state[slice.name][screen].currency
export const selectUnit = (screen) => (state) => state[slice.name][screen].unit

export const {
  resetStoreSelectCurrencyUnit,
  resetStoreSelectCurrencyUnitExceptExchangeRates,
  changeExchangeRates,
  changeCurrency,
  changeAllCurrency,
  changeUnit,
  changeAllUnit,
  changeAllowSetDefaultUnit,
  calculateDefaultUnit,
} = slice.actions

register(slice.name, slice.reducer, persistKeys)
